import { render, staticRenderFns } from "./ai-qa-config.vue?vue&type=template&id=d8e1ab26&scoped=true"
import script from "./ai-qa-config.vue?vue&type=script&lang=ts"
export * from "./ai-qa-config.vue?vue&type=script&lang=ts"
import style0 from "./ai-qa-config.vue?vue&type=style&index=0&id=d8e1ab26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e1ab26",
  null
  
)

export default component.exports